module.exports = __webpack_public_path__ + "static/media/order_tobacco_active.3f344da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_tobacco_active.png
// module id = 1651
// module chunks = 0